import { forwardRef } from 'react'

import { useCurrentEditor } from '@tiptap/react'
import {
  Bold,
  Heading1,
  Heading2,
  Heading3,
  Italic,
  List,
  ListOrdered,
  Strikethrough,
} from 'lucide-react'

import { Toggle } from '../../toggle/toggle'

// menubar
export const MenuBar = forwardRef<HTMLDivElement>((_, ref) => {
  const { editor } = useCurrentEditor()

  if (!editor) {
    return null
  }

  return (
    <div className="flex h-fit w-fit items-center rounded-md border" ref={ref}>
      <div className="p-xs">
        <Toggle
          disabled={!editor.can().chain().focus().toggleBold().run()}
          onPressedChange={() => editor.chain().focus().toggleBold().run()}
          pressed={editor.isActive('bold')}
          size="sm"
        >
          <Bold size={16} />
        </Toggle>
        <Toggle
          disabled={!editor.can().chain().focus().toggleItalic().run()}
          onPressedChange={() => editor.chain().focus().toggleItalic().run()}
          pressed={editor.isActive('italic')}
          size="sm"
        >
          <Italic size={16} />
        </Toggle>
        <Toggle
          disabled={!editor.can().chain().focus().toggleStrike().run()}
          onPressedChange={() => editor.chain().focus().toggleStrike().run()}
          pressed={editor.isActive('strike')}
          size="sm"
        >
          <Strikethrough size={16} />
        </Toggle>
      </div>
      <div className="p-xs border-l">
        <Toggle
          onPressedChange={() =>
            editor.chain().focus().toggleHeading({ level: 1 }).run()
          }
          pressed={editor.isActive('heading', { level: 1 })}
          size="sm"
        >
          <Heading1 size={16} />
        </Toggle>
        <Toggle
          onPressedChange={() =>
            editor.chain().focus().toggleHeading({ level: 2 }).run()
          }
          pressed={editor.isActive('heading', { level: 2 })}
          size="sm"
        >
          <Heading2 size={16} />
        </Toggle>
        <Toggle
          onPressedChange={() =>
            editor.chain().focus().toggleHeading({ level: 3 }).run()
          }
          pressed={editor.isActive('heading', { level: 3 })}
          size="sm"
        >
          <Heading3 size={16} />
        </Toggle>
      </div>
      <div className="border-l p-1">
        <Toggle
          onPressedChange={() =>
            editor.chain().focus().toggleBulletList().run()
          }
          pressed={editor.isActive('bulletList')}
          size="sm"
        >
          <List size={16} />
        </Toggle>
        <Toggle
          onPressedChange={() =>
            editor.chain().focus().toggleOrderedList().run()
          }
          pressed={editor.isActive('orderedList')}
          size="sm"
        >
          <ListOrdered size={16} />
        </Toggle>
      </div>
    </div>
  )
})

MenuBar.displayName = 'MenuBar'
